import { render, staticRenderFns } from "./Paynow.vue?vue&type=template&id=54a3fbf0&scoped=true&"
import script from "./Paynow.vue?vue&type=script&lang=js&"
export * from "./Paynow.vue?vue&type=script&lang=js&"
import style0 from "./Paynow.vue?vue&type=style&index=0&id=54a3fbf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a3fbf0",
  null
  
)

/* custom blocks */
import block0 from "./Paynow.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports